/**
 * Carousel Equal Heights
 * 
 * Equalizes the heights of all slides in the carousel-blades component
 */
document.addEventListener('DOMContentLoaded', function() {
    // Function to equalize slide heights
    function equalizeSlideHeights() {
        const carouselWrapper = document.querySelector('.carousel-blades-wrapper');
        if (!carouselWrapper) return;
        
        const slides = carouselWrapper.querySelectorAll('.tns-item');
        if (!slides.length) return;
        
        // Reset heights first
        slides.forEach(slide => {
            slide.style.height = 'auto';
        });
        
        // Find the tallest slide
        let maxHeight = 0;
        slides.forEach(slide => {
            const height = slide.offsetHeight;
            maxHeight = Math.max(maxHeight, height);
        });
        
        // Set all slides to the tallest height
        slides.forEach(slide => {
            slide.style.height = maxHeight + 'px';
            
            // Also set the card inside to the same height
            const card = slide.querySelector('.card');
            if (card) {
                card.style.height = '100%';
            }
        });
    }

    // Run after tiny slider is initialized
    setTimeout(equalizeSlideHeights, 500);
    
    // Also run on window resize
    window.addEventListener('resize', function() {
        setTimeout(equalizeSlideHeights, 100);
    });
}); 